<div id="page-container">
  <div id="content-wrap">
    <!-- <vc-poll-pages-header [title]="title" [isLive]="isLive" [isPublic]="isPublic" [quorum]="quorum" [quorumActual] = "quorumActual"
      [SMSOption]="isSms" [is2FA]="is2FA" [isAssessors]="hasAssessorsButtons" (downloadQuorumFile)="downloadQuorumFile()">
    </vc-poll-pages-header> -->
    <vc-poll-overview-header [title]="title" [isLive]="isLive" [isPublic]="isPublic" [SMSOption]="isSms" [is2FA]="is2FA"
      [isAssessors]="hasAssessorsButtons" [opened]="isOpen" [image]="pollImage"
      [suspended]="suspended"></vc-poll-overview-header>

    <!-- <vc-poll-ongoing-summary [description]="description" [startDate]="startDate" [endDate]="endDate"
      [votersVoted]="votes" [votersCount]="votersCount" (return)="rejoinPoll()" [isLive]="isLive"
      [isSms]="isSms" [isPublic]="isPublic" [is2FA]="is2FA" [type]="votingType" (refreshDataEvent)="refreshData()"
      [participation]="percentageString" [sharedLinks]="sharedLinks">
    </vc-poll-ongoing-summary> -->

    <vc-poll-planned-countdown [timeDelta]="timeDifference" [timeDiffHours]="remainingTime" [title]="title"
      [hasAssessorsButtons]="hasAssessorsButtons" [opened]="isOpen" [votersVoted]="votes" [votersCount]="votersCount"
      (refreshDataEvent)="refreshData()" [suspended]="suspended">
    </vc-poll-planned-countdown>
    <!-- <vc-poll-ongoing-timer [timeDelta]="timeDifference" [isLive]="isLive" [isPublic]="isPublic"
      (shouldDisplayVoters)="displayVoters()" [sent]="emailsSent" [inviteDate]="inviteDate"
      [timeDiffHours]="remainingTime" (shouldRelaunchInvitations)="displayRelaunchWarning()"
      [displayChangeVoters]="true" (shouldChangeVoters)="changeVoter()" [showPreCloseButton]="showPreCloseButton"
      (sendPreCloseWarning)="displayPreCloseWarning()">
    </vc-poll-ongoing-timer> -->

    <p-panel>
      <p class="text-md dark-blue"><img src="assets/calendar25.svg" class="icon-inline">Période du scrutin : du
        {{startDate}} au {{endDate}}</p>
      <p class="text-md dark-blue"><img width="18px" id="silhouette" style="margin-right: 10px;"
          src="assets/silhouette_icon_black.svg">Invités au scrutin : <span class="bold">{{votersCount}}</span></p>
    </p-panel>

    <div class="custom-accordion-container light-border" *ngIf="description && description.trim() !== ''">
      <div class="custom-accordion-item" (click)="toggleDescription()">
        <p class="text-md dark-blue custom-description" [class.expanded]="isDescriptionExpanded">
          {{isDescriptionExpanded ? description : getTruncatedDescription()}}
        </p>
        <i class="pi pi-chevron-down custom-arrow" [class.rotated]="isDescriptionExpanded"></i>
      </div>
    </div>

    <div *ngIf="votingType == 'list'">
      <div class="default-bloc flex gap-10 align-items-center">
        <img src="assets/icon-participation.svg" alt="">
        <p class="no-margin light-blue bold">Participation globale</p>
      </div>
      <div class="default-bloc mt-10">
        <p class="dark-blue bold text-md no-margin">TITULAIRES</p>
      </div>
      <div *ngIf="cseParticipation != undefined" class="grid-col-3 default-bloc mt-10">
        <div class="p-10 flex flex-column content-evenly text-center"
          style="border: solid 1px #DCEEFF; border-top: solid 3px #2B2D67;">
          <p class="dark-blue bold text-xl no-margin">{{cseParticipation.allTitularVoters}}</p>
          <p class="dark-blue text-md no-margin mt-10">ELECTEURS INSCRITS</p>
        </div>
        <div class="p-10 flex flex-column content-evenly text-center"
          style="border: solid 1px #DCEEFF; border-top: solid 3px #1990FF;">
          <p class="light-blue bold text-xl no-margin">{{ cseParticipation.allTitularVotes }}</p>
          <p class="light-blue text-md no-margin mt-10">VOTES ENREGISTRÉS</p>
        </div>
        <div class="p-10 flex flex-column content-evenly text-center"
          style="border: solid 1px #DCEEFF; border-top: solid 3px #32A24C;">
          <p class="no-margin text-xl bold strong-green">{{getTitularPercentage()}}%</p>
          <p class="no-margin text-md strong-green mt-10">TAUX DE PARTICIPATION</p>
        </div>
      </div>
      <div class="default-bloc mt-10">
        <p class="dark-blue bold text-md no-margin">SUPPLÉANTS</p>
      </div>
      <div *ngIf="cseParticipation != undefined" class="grid-col-3 default-bloc mt-10">
        <div class="p-10 flex flex-column content-evenly text-center"
          style="border: solid 1px #DCEEFF; border-top: solid 3px #2B2D67;">
          <p class="dark-blue bold text-xl no-margin">{{ cseParticipation.supplementaryVoters }}</p>
          <p class="dark-blue text-md no-margin mt-10">ELECTEURS INSCRITS</p>
        </div>
        <div class="p-10 flex flex-column content-evenly text-center"
          style="border: solid 1px #DCEEFF; border-top: solid 3px #1990FF;">
          <p class="no-margin text-xl bold light-blue">{{ cseParticipation.supplementaryVotes }}</p>
          <p class="no-margin text-md light-blue mt-10">VOTES ENREGISTRÉS</p>
        </div>
        <div class="p-10 flex flex-column content-evenly text-center"
          style="border: solid 1px #DCEEFF; border-top: solid 3px #32A24C;">
          <p class="no-margin text-xl bold strong-green">{{ getSupplementaryPercentage() }}%</p>
          <p class="no-margin text-md strong-green mt-10">TAUX DE PARTICIPATION</p>
        </div>
      </div>

      <div class="default-bloc mt-20 flex gap-10 align-items-center">
        <img src="assets/icon-participation.svg" alt="">
        <p class="no-margin light-blue bold">Participation par collège</p>
      </div>
      <div class="flex flex-column mt-10 default-bloc">
        <div class="flex">
          <button *ngIf="colleges.length >= 1" type="button" (click)="selectCollege(1)" class="p-10"
            style="border: solid 1px #DCEEFF; min-width: 120px;"
            [ngClass]="roundPartToDisplay == 1 ? 'bg-light-blue white' : 'bg-white light-blue'">
            {{colleges[0].displayName}}
          </button>
          <button *ngIf="colleges.length >= 2" type="button" (click)="selectCollege(2)" class="p-10"
            style="border: solid 1px #DCEEFF; min-width: 120px;"
            [ngClass]="roundPartToDisplay == 2 ? 'bg-light-blue white' : 'bg-white light-blue'">
            {{colleges[1].displayName}}
          </button>
          <button *ngIf="colleges.length >= 3" type="button" (click)="selectCollege(3)" class="p-10"
            style="border: solid 1px #DCEEFF; min-width: 120px;"
            [ngClass]="roundPartToDisplay == 3 ? 'bg-light-blue white' : 'bg-white light-blue'">
            {{colleges[2].displayName}}
          </button>
          <!-- <v8te-active-button *ngIf="colleges.length >= 1" [buttonText]=colleges[0].displayName
            [icon]="'assets/v8te.png'" [iconPosition]="'left'" [height]="50" (click)="selectCollege(1)"
            [active]="roundPartToDisplay == 1"></v8te-active-button>
          <v8te-active-button *ngIf="colleges.length >= 2" [buttonText]=colleges[1].displayName
            [icon]="'assets/v8te.png'" [iconPosition]="'left'" [height]="50" (click)="selectCollege(2)"
            [active]="roundPartToDisplay == 2"></v8te-active-button>
          <v8te-active-button *ngIf="colleges.length >= 3" [buttonText]=colleges[2].displayName
            [icon]="'assets/v8te.png'" [iconPosition]="'right'" [height]="50" (click)="selectCollege(3)"
            [active]="roundPartToDisplay == 3"></v8te-active-button> -->
        </div>
        <div style="border: solid 1px #DCEEFF;" class="p-20">
          <p *ngIf="colleges.length > 0" class="dark-blue no-margin mb-20">
            <span id="exclamation-orange">!</span> Composition précise : <span class="bold">{{collegeType}}</span>
          </p>
          <div *ngIf="cseParticipation != undefined" class="grid-col-3 items-center"
            style="border-top: solid 1px #DCEEFF; padding-top: 20px;">
            <div class="p-10 flex flex-column content-evenly w-full">
              <div class="flex gap-10">
                <img src="assets/silhouette_icon_black.svg" alt="black silhouette" width="20px">
                <p class="dark-blue bold text-md no-margin">TITULAIRES</p>
              </div>
              <div class="flex flex-column content-evenly radius-10">
                <p class="dark-blue flex align-items-center content-between no-margin">
                  <span>Votants </span><span class="bold p-10"
                    style="border: solid 1px #E7F4FF; border-radius: 10px;">{{partParColleges[0]}}/{{partParColleges[1]}}</span>
                </p>
                <p class="dark-blue flex align-items-center content-between no-margin">
                  <span>Taux de participation </span><span class="bold p-10"
                    style="border: solid 1px #E7F4FF; border-radius: 10px;">{{partParColleges[2]}}%</span>
                </p>
              </div>
            </div>
            <div style="width: 1px; height: 100%; background-color: #DCEEFF;"></div>
            <div class="p-10 flex flex-column content-evenly w-full">
              <div class="flex gap-10">
                <img src="assets/silhouette_icon_black.svg" alt="black silhouette" width="20px">
                <p class="dark-blue bold text-md no-margin">SUPPLÉANTS</p>
              </div>
              <div class="flex flex-column content-evenly radius-10">
                <p class="dark-blue flex align-items-center content-between no-margin">
                  <span>Votants </span><span class="bold p-10"
                    style="border: solid 1px #E7F4FF; border-radius: 10px;">{{partParColleges[3]}}/{{partParColleges[4]}}</span>
                </p>
                <p class="dark-blue flex align-items-center content-between no-margin">
                  <span>Taux de participation </span><span class="bold p-10"
                    style="border: solid 1px #E7F4FF; border-radius: 10px;">{{partParColleges[5]}}%</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showAdminButtons" class="grid-col-2 items-center default-bloc mt-20">
      <button id="button-see-voters" class="action-button" (click)=displayVoters()>{{'TIMER.NONVOTERS' |
        translate}}</button>

      <div *ngIf="emailsSent == false" style="text-align: center;">
        <button class="action-button" (click)=displayRelaunchWarning()>{{'TIMER.RELAUNCH' |
          translate}}</button>
      </div>
      <div *ngIf="emailsSent == true" style="text-align: center;">
        <button class="disabled-action-button">{{'TIMER.RELAUNCH' | translate}}</button>
        <div style="text-align: center">
        </div>
        <div *ngIf="remainingTime != null" class="clock-holder flex gap-5">
          <img class="clock-icon" src="assets/clock.svg">
          <p class="text-sm dark-blue">{{'POLL-ONGOING.RESEND-TIME' | translate}}{{remainingTime}}</p>
        </div>
      </div>
      <button class="action-button" style="margin-top: 0px" (click)="changeVoter()"> {{'POLL-FINISHED.CHANGE-VOTERS' |
        translate}}</button>
      <div *ngIf="votingType == 'list'" style="text-align: center">
        <button *ngIf="!suspended" class="action-button orange-button" (click)="triggerSuspendPopup()">Suspendre le
          vote</button>
        <button *ngIf="suspended" class="action-button green-action-button" (click)="triggerResumePopup()">Reprendre le
          vote</button>
      </div>
    </div>

    <!-- END EDIT  -->

    <div *ngIf="votingType == 'resolution' || votingType == 'live'">
      <vc-poll-planned-list class="resolutions" [votingType]="votingType" [answers]="answers"
        (editionEventEmitter)="editPoll()">
      </vc-poll-planned-list>
    </div>
    <!-- votingType == 'planned' à retirer à terme car ne sera plus utilisé -->
    <div *ngIf="(votingType == 'election' || votingType == 'planned') && !isLive">
      <vc-poll-planned-list *ngFor="let candidate of candidates, let index = index" class="election"
        [votingType]="votingType" [candidates]="candidate" [answers]="answers[0]"
        [numberOfVote]="answers[0].numberOfVote" (editionEventEmitter)="editPoll()" [index]="index">
      </vc-poll-planned-list>
    </div>
    <!-- <div *ngIf="votingType == 'list'" class="grid-col-2 form-holder">
      <vc-poll-list *ngFor="let list of lists, let round = index" class="list" [votingType]="votingType"
        [answers]="list" [numberOfVote]="list.numberOfVote" (editionEventEmitter)="editPoll()" [titles]="titles"
        [pollId]="pollId" [displayBlockchain]="true" [index]="round">
      </vc-poll-list>
    </div> -->
    
  </div>
</div>
<div *ngIf="isError">
  <app-error (isClosed)="common.navigateToPolls()" [errorMessage]="errorMessage">
  </app-error>
</div>
<div *ngIf="shouldDisplayVoters">
  <!-- <vc-warning-popup title="{{'REMAINING-VOTERS' | translate}}" [mails]="remainingVoters" [understoodEndButton]="true"
    (endDetailsPopup)="dismissVoters()" [separator]="false" [downloadButton]="true"
    (sendDownloadOrder)="downloadVoterFile()">
  </vc-warning-popup> -->
  <voters-list-popup [mails]="remainingVoters" (endDetailsPopup)="dismissVoters()"
    (sendDownloadOrder)="downloadVoterFile()">
  </voters-list-popup>
</div>
<div *ngIf="displayPreClosePopup">
  <vc-warning-popup
    title="Etes-vous sûr de vouloir faire cela ? Si vous cliquez sur le bouton de confirmation, vous ne pourrez plus revenir en arrière."
    (endDetailsPopup)="dismissForceClose($event)" [cancelButton]="true" [confirmButton]="true">
  </vc-warning-popup>
</div>
<div *ngIf="shouldDisplayRelaunchWarning">
  <!-- <app-voters-relaunch (isClosed)="handleRelaunch($event)" [isResend]=true>
  </app-voters-relaunch> -->
  <voters-relaunch-popup (isClosed)="handleRelaunch($event)" [isResend]=true></voters-relaunch-popup>
</div>
<div *ngIf="displaySuspendPopup">
  <app-suspend-popup (suspendMessage)="handleSuspendMessage($event)" (isClosed)="handleSuspend($event)" [isResend]=true
    [assessors]="assessors" (sendAssessorKey)="handleSuspendAssessorKey($event)"
    [suspendErrorMessage]="suspendErrorMessage" [suspendActiveAssessors]="suspendActiveAssessors">
  </app-suspend-popup>
</div>
<div *ngIf="displayResumePopup">
  <app-resume-popup (suspendMessage)="handleSuspendMessage($event)" (isClosed)="handleResume($event)" [isResend]=true
    [assessors]="assessors" [suspendErrorMessage]="suspendErrorMessage"
    [suspendActiveAssessors]="suspendActiveAssessors" (sendAssessorKey)="handleSuspendAssessorKey($event)">
  </app-resume-popup>
</div>
<div *ngIf="displayConfirmSuspendPopup">
  <confirm-suspend-popup [title]="title" (isClosed)="handleConfirmSuspend($event)" [votersCount]="votersCount"
    [startDate]="startDate" [endDate]="endDate">
  </confirm-suspend-popup>
</div>
<div *ngIf="displayConfirmResumePopup">
  <confirm-resume-popup [title]="title" (isClosed)="handleConfirmResume($event)" [votersCount]="votersCount"
    [startDate]="startDate" [endDate]="endDate">
  </confirm-resume-popup>
</div>
<div *ngIf="resendOngoingLoader">
  <vc-loader messageToTheUser="{{'LOADER.RESEND' | translate}}">
  </vc-loader>
</div>
<div *ngIf="shouldChangeVoter">
  <transfer-voters-popup (closeChangeVoter)="closeChangeVoter($event)" [pollId]="pollId">
  </transfer-voters-popup>
  <!-- <app-change-voter (closeChangeVoter)="closeChangeVoter($event)" [pollId]="pollId">
  </app-change-voter> -->
</div>
<div *ngIf="shouldDisplayChangeVoterValidation">
  <app-valid-voter-changes (close)="closeChangeValidation()"></app-valid-voter-changes>
  <!-- <app-valid-changes (close)="closeChangeValidation()"></app-valid-changes> -->
</div>
